import {GET_CLAIM_REQUEST, GET_CLAIM_SUCCESS,GET_CLAIM_FAILUER } from "./types"

export const getclaimrequest = () => {
    return {
        type: GET_CLAIM_REQUEST
    }
}

export const getclaimSuccess = (cred) => {
    return {
        type: GET_CLAIM_SUCCESS,
        payload: cred
    }
}

export const getclaimFailure = (error) => {
    return {
        type: GET_CLAIM_FAILUER,
        payload: error
    }
}